import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import { connect } from 'react-redux';
import { Card, CardHeader, CardBody, CardFooter, Col, Row, Alert } from 'reactstrap';
import { BsBellFill, BsClock } from "react-icons/bs";
import { Spinner } from 'react-bootstrap';
import {Link} from "react-router-dom";


class NotiAdminDetailComponent extends React.Component {

	 constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
			error: false,
            messageError: '',
            btnSubmit: true,
            notiAdmin: {},
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailNotiAdmin(this.props.notiAdminId);
    }

    componentDidUpdate(prevProps) {
        if (this.props.notiAdminId !== prevProps.notiAdminId) {
            this.getDetailNotiAdmin( this.props.notiAdminId );
        }
    }

	getDetailNotiAdmin = (notiAdminId) => {
		this.setState({
			loadPage: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			},
		  	params: {id: notiAdminId}
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/noti-admin/detail', config)
		.then( (ref) => {
			// console.log(ref.data);
			this.setState({
				loadPage: false,
				error: false,
				messageError: '',
			});
			if ( ref.data.error === 0 ) {
				this.setState({
					notiAdmin: ref.data.content,
				},
				() => this.loadUnreadNotiAdmin()
				);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
					});
					this.redirect();
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				loadPage: false,
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			});
		})
	}

    redirect = () => {
        this.props.notification({
            isNotification: true,
            textNotification: 'Thông báo không tồn tại hoặc không thuộc quyền quản lý của quý khách. Quý khách vui lòng kiểm tra lại'
        });
        this.props.shouldRedirect();
    }

    checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

    loadNotiAdminDetail = () => {
    	if (Object.keys(this.state.notiAdmin).length) {
    		return (
    			<>
    				<Card>
                        <CardHeader>
                            <h3 className="card-title">
                                { this.state.notiAdmin.title }
                            </h3>
                            <div style={{color: '#999', fontSize: 13}}>
                                <BsClock /> {this.state.notiAdmin.created_at}
                            </div>
                        </CardHeader>
                        <CardBody>
                            <div className="content-noti" dangerouslySetInnerHTML={{ __html: this.state.notiAdmin.content }}>
                            </div>
                        </CardBody>
                        <CardFooter>
                            <div>
                                <Link to="/admin/noti-admin/" className="btn btn-default">Tất cả thông báo</Link>
                            </div>
                        </CardFooter>
                    </Card>
		        </>
			)
    	}
    }

    loadUnreadNotiAdmin = () => {
        if(this.props.noti_admins.length > 0) {
            this.props.noti_admins.forEach( (noti_admin) => {
                if (noti_admin.id === this.state.notiAdmin.id) {
                    this.getUnReadNotiAdmins();
                }
            });
        }
    }

    getUnReadNotiAdmins = () => {
	    let dataAuth = {
	        username: process.env.REACT_APP_CLIENT_ID,
	        password: process.env.REACT_APP_CLIENT_PASSWD,
	        token: process.env.REACT_APP_KEY,
	    };

	    let config = {
	        headers: {
		        'Content-Type': 'application/json',
		        'Authorization' : this.props.token,
		        'dataAgency' : JSON.stringify(dataAuth)
	        }
	    }

	    axios.get(process.env.REACT_APP_API_URL + '/api/admin/noti-admin/get-unread-noti-admin', config )
	    .then((ref) => {
	        // console.log(ref.data);
	        if (ref.data.error === 0) {
	            this.updateNotiAdmin(ref.data)
	        } else {
	            if (ref.data.error > 9000) {
	                this.props.logOut();
	            } else {
	                this.setState({
	                    error: true,
	                    messageError: ref.data.message
	                })
	            }
	        }
	    })
	    .catch((error) => {
	        console.log(error);
	        this.setState({
	            error: true,
	            messageError: 'Lấy dữ liệu thông báo thất bại',
	        })
	    })
    }

    updateNotiAdmin = (data) => {
        let itemNotiAdmin = {
            noti_admins: data.noti_admins,
            unread_noti_admin: data.unread_noti_admin
        }
        this.props.updateNotiAdmin(itemNotiAdmin);
    }

	render() {
		return (
			<>
				{
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <Breadcrumb title={"Chi tiết thông báo"} page={"Chi tiết thông báo"} icon={<BsBellFill className="breadcrumb-icon" />} />

                           <Row style={{ marginTop: 20 }}>
								<Col sm={12}>
									{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
									{this.checkNotification()}
								</Col>
							</Row>
							{ this.loadNotiAdminDetail() }
                        </>
                    )
                }
			</>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	    noti_admins: state.agency.noti_admins,
    	unread_noti_admin: state.agency.unread_noti_admin,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminNotiDetail' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
		updateNotiAdmin: (item) => {
            dispatch(({type: 'updateNotiAdmin', item}))
        },
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(NotiAdminDetailComponent);